module.exports = __webpack_public_path__ + "assets/default.0d9a7c00.png";